import Vue from 'vue';
import VueRouter from 'vue-router';
import InfiniteScroll from 'vue-infinite-scroll';

Vue.use(VueRouter);
Vue.use(InfiniteScroll);

window.Application = require('./application.js').default;
window.Common = require('./common.js').default;
window.UserAPI = require('./api/user.js').default;
window.DictionaryAPI = require('./api/dictionary.js').default;
window.FeedbackAPI = require('./api/feedback.js').default;
window.ContentAPI = require('./api/content.js').default;
window.AppealAPI = require('./api/appeal.js').default;
window.IncidentAPI = require('./api/incident.js').default;
window.FileStorageAPI = require('./api/fileStorage.js').default;
window.MapAPI = require('./api/map.js').default;
window.MunicipalityAPI = require('./api/docMunicipality.js').default;
window.AppealSubjectApi = require('./api/appealSubjectApi.js').default;
window.AddressAPI = require('./api/address.js').default;

const Home = resolve => require(['./pages/Home.vue'], resolve);
const Contacts = resolve => require(['./pages/Contacts.vue'], resolve);
const News = resolve => require(['./pages/News.vue'], resolve);
const Article = resolve => require(['./pages/Article.vue'], resolve);
const Appeal = resolve => require(['./pages/Appeal.vue'], resolve);
const Documents = resolve => require(['./pages/Documents.vue'], resolve);
const UserAppeals = resolve => require(['./pages/UserAppeals.vue'], resolve);
const CustomPage = resolve => require(['./pages/CustomPage.vue'], resolve);
const Config = resolve => require(['./pages/Config.vue'], resolve);

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', component: News, canReuse: true },
        { path: '/contacts', component: Contacts, canReuse: true },
        { path: '/news', component: News, canReuse: true },
        { path: '/article/:id', component: Article, canReuse: true },
        { path: '/appeal', component: Appeal, canReuse: true },
        { path: '/documents', component: Documents, canReuse: true },
        { path: '/appeals', component: UserAppeals, canReuse: true },
        { path: '/version', component: Config, canReuse: true },
        { path: '/:id', component: CustomPage, canReuse: true },

    ]
});

window.VueRouter = router;

const app = new Vue({
    el: '#app',
    router: router,
    data: {
        currentRoute: window.location.pathname
    },
    render (h) {
        return h(require('./layouts/Main.vue'));
    }
});



// WEBPACK FOOTER //
// ./src/main.js